// Help pages: muted "Last updated" line and an "On this page" list built from the section headings.
(() => {
  // On mobile the help navigation scrolls sideways; bring the current page into view.
  const current = document.querySelector('.iah-help-nav [aria-current="page"]');
  if (current) {
    const list = current.closest('ul');
    list.scrollLeft += current.getBoundingClientRect().left - list.getBoundingClientRect().left - 15;
  }

  const body = document.querySelector('.iah-help .shopify-policy__body');
  const toc = document.querySelector('[data-iah-help-toc]');
  if (!body) return;

  const first = body.querySelector('.rte > p');
  if (first && /^last updated/i.test(first.textContent.trim())) first.classList.add('iah-help__updated');

  const headings = [...body.querySelectorAll('h2, h3')];
  if (!toc || headings.length < 3) return;

  const list = document.createElement('ol');
  const links = new Map();
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `section-${index + 1}`;
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    const item = document.createElement('li');
    item.append(link);
    list.append(item);
    links.set(heading, link);
  });
  toc.append(list);
  toc.hidden = false;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        links.forEach((link) => link.removeAttribute('aria-current'));
        links.get(entry.target).setAttribute('aria-current', 'true');
      });
    },
    { rootMargin: '0px 0px -70% 0px' }
  );
  headings.forEach((heading) => observer.observe(heading));
})();
